import { AfterViewInit, Component, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "../../main/auth.service";
import { environment } from "../../../environments/environment";
import { ArkUserType } from "../../core/api/models";
import { HttpClient } from "@angular/common/http";
import { Utils } from "../../core/utils";
import { AlertService } from "../../shared/services/alert.service";
import { Table } from "primeng/table";
import { formatDate } from "@angular/common";

interface GithubReleaseNotesViewModel {
  PullRequestNumber: number;
  Repository?: string | null;
  Title?: string | null;
  PullRequestUrl?: string | null;
  PullRequestCreatedAt?: string | null;
  PullRequestUpdatedAt?: string | null;
  ReleaseNotesCommentId?: number | null;
  ReleaseNotesAuthor?: string | null;
  ReleaseNotesDate?: string | null;
  ReleaseNotesHtml?: string | null;
  ReleaseNotesPlainText?: string | null;
  HasReleaseNotesDraft: boolean;
}


@Component({
  selector: 'app-release-notes-component',
  templateUrl: './release-notes.component.html',
  styleUrl: './release-notes.component.css',
  standalone: false
})
export class ReleaseNotesComponent implements OnInit, AfterViewInit {

  releases: GithubReleaseNotesViewModel[] = [];
  loadingList: boolean = false;
  expandedRows: any = {};

  @ViewChild('dt1') table?: Table;

  constructor(private authService: AuthService,
    private http: HttpClient,
    private alertService: AlertService) {
  }


  ngOnInit(): void {
    this.authService.checkIfAutorized([ArkUserType.Support, ArkUserType.Admin]);
    this.loadTable();
  }

  ngAfterViewInit(): void {
  }

  loadTable() {
    this.loadingList = true;
    this.http.get<GithubReleaseNotesViewModel[]>(`${environment.webApiRoot}/api/ReleaseNotes/List`)
      .forEach((result) => {
        this.releases = result || [];
        this.loadingList = false;
      }).catch(err => {
        this.alertService.error(Utils.getAjaxError(err));
        this.loadingList = false;
      });
  }

  clear(table: Table) {
    this.table = table;
    table.clear();
  }

  getTimeFromNow(value: string | null | undefined) {
    if (!value)
      return '-';

    if ((new Date().getTime()) - (new Date(value).getTime()) > 1000 * 60 * 60 * 36)
      return formatDate(value, 'shortDate', 'en-US');

    return Utils.getTimeFromNow(new Date(value));
  }

  openPullRequest(item: GithubReleaseNotesViewModel) {
    if (!item.PullRequestUrl)
      return;

    var w = window.open(item.PullRequestUrl);
    if (!w)
      location.href = item.PullRequestUrl;
  }

}
